// Predefined constants for known auth type descriptions
export const AUTH_TYPE = {
    UsernamePassword: 'Username/Password',
    GoogleSocial: 'Google Social',
    GoogleWorkspace: 'Google Workspace'
};
